// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.singleNavigationButton[data-v-50f528a6] {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 1em 2em;\n}\n.spacedBetweenButton[data-v-50f528a6] {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 1em 2em;\n}\n", ""]);
// Exports
module.exports = exports;
